// eventBus.js
//import { reactive } from 'vue';

const state = new Map();

export const eventBus = {
  on(event, callback) {
    const callbacks = state.get(event) || [];
    callbacks.push(callback);
    state.set(event, callbacks);
  },
  off(event, callback) {
    const callbacks = state.get(event) || [];
    const index = callbacks.indexOf(callback);
    if (index > -1) {
      callbacks.splice(index, 1);
      state.set(event, callbacks);
    }
  },
  emit(event, ...args) {
    const callbacks = state.get(event) || [];
    callbacks.forEach((callback) => callback(...args));
  },
};
export default eventBus;
